export default __webpack_public_path__ + "static/media/linkedin-in-brands.26f9706f.png";